/* --------------------------------------------------------------------------------------
   classes.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const classesComponent  = {
    template: require('./classes.html'),
    controller: 'classesCtrl',
    controllerAs: 'vm',
    bindings: {
      back: '&',
      next: '&'
    }
}

export class classesCtrl {
  /*@ngInject*/
  constructor (commonService, dataService, appService, $scope) {
    this.commonService = commonService
    this.dataService = dataService
    this.appService = appService
    this.$scope = $scope
  }
  $onInit () {
    this.commonService.setDefaultBackground()
    this.dataService.GetClasses()
      .then(result => this.setItems(result))
      .then(length => this.setSegmentedSizesAndScroll(length))
      .catch(error => {
        this.appService.handleError(error)
          .then(result => {this.error = result})
      })
  }
  setSegmentedSizesAndScroll(itemCount) {
    this.width = (this.commonService.getScreenWidth() > 801)? '935':'760'
    let maxVisibleItems = (this.commonService.getScreenHeight() > 481)? 7:5
    let maxHeight = (this.commonService.getScreenHeight() > 481)? '460':'350'
    if (itemCount <= maxVisibleItems) {
      this.scroll = false
    }
    else {
      this.scroll = true
      this.height = maxHeight
    }
    this.ready = true
  }
  setItems(items) {
    this.items = items
    if (this.items.length)
      this.selectedClass = this.items[0]
    return items.length
  }
  selectClass(item) {
    this.selectedClass = {ID: item.value, Name: item.label}
  }
  submit() {
    this.appService.classId = this.selectedClass.ID
    this.appService.className = this.selectedClass.Name
    this.next()
  }
  toggleDisable() {
    $('#next-button').xrxbutton({disabled: true})
  }
  errorClosed() {
    return this.appService.errorClosed(this.error)
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/classes.component.js